import React, { forwardRef, useContext } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { ThemeContext } from "../Theme";

import TileContent from "./TileContent";
import TileButton from "./TileButton";

import styles from "./Tile.scss";

export const Tile = forwardRef((props, ref) => {
  const { children, variant, hover, customClass, ...otherProps } = props;
  const theme = useContext(ThemeContext);

  const styleTile = cx(styles.tile, {
    [styles.shadow]: variant === "shadow",
    [styles.hover]: hover,
    [styles[theme]]: theme,
    [customClass]: customClass,
  }, customClass);

  return (
    <div className={styleTile} ref={ref} {...otherProps}>
      {children}
    </div>
  );
});

Tile.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  variant: PropTypes.oneOf(["outline", "shadow"]),
  hover: PropTypes.bool,
  customClass: PropTypes.string,
};

Tile.defaultProps = {
  variant: "outline",
  customClass: null,
  hover: false,
};

Tile.Content = TileContent;
Tile.Button = TileButton;

Tile.displayName = "Tile";

export default Tile;
